import { defineComponent as _defineComponent } from 'vue'
import { PaymentFormValues } from "@/modules/Missions/components/Payment/CreatePaymentStructureForm.vue"
import { MissionLifecycleFragmentFragment } from "@/gql"
import MoneyDisplay from "@/components/feature/MoneyDisplay.vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import { computed } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'LinkPaymentPreview',
  props: {
    payment: null,
    mission: null
  },
  emits: ["linkClientPayment"],
  setup(__props: any, { emit }: { emit: ({
  (e: "linkClientPayment"): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  payment: PaymentFormValues
  mission: MissionLifecycleFragmentFragment
}





const getClientPayment = (prn: string) => {
  return props.mission.missionContract?.missionContractPayments.find(
    (payment) => payment.prn === prn
  )
}

const clientPayment = computed(() => {
  if (!props.payment.clientPayment) return null
  return getClientPayment(props.payment.clientPayment)?.amount.format ?? null
})

return { __sfc: true,props, emit, getClientPayment, clientPayment, MoneyDisplay, Icon }
}

})